import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSquareBehindSquare4"><Path fillRule="evenodd" clipRule="evenodd" d="M8 8V4C8 2.89543 8.89543 2 10 2H20C21.1046 2 22 2.89543 22 4V14C22 15.1046 21.1046 16 20 16H16V20C16 21.1046 15.1046 22 14 22H4C2.89543 22 2 21.1046 2 20V10C2 8.89543 2.89543 8 4 8H8ZM10 16C8.89543 16 8 15.1046 8 14V9.5H4C3.72386 9.5 3.5 9.72386 3.5 10V20C3.5 20.2761 3.72386 20.5 4 20.5H14C14.2761 20.5 14.5 20.2761 14.5 20V16H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare4;
